import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import {
    MainFilters,
    MainFiltersParams,
} from 'components/main-filters/main-filters';
import { RaceFilterForm } from 'features/cms/components/race-kit-filter-form/race-kit-filter-form';
import { RacekitTable } from 'features/cms/components/race-kit-tabel';
import { AddRacekitmodal } from 'features/cms/components/race-kit-tabel/add-racekit-modal/add-racekit-modal';
import { raceFilterFormPaginated, RaceFilterFormValues } from 'features/cms/components/type';
import { useGetRacekit } from 'features/cms/use-cases/get-racekit';
import { usePermissions } from 'features/users';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const { useBreakpoint } = Grid;

const initialFilterValues: RaceFilterFormValues = {
    name: undefined,
};

export const RacekitView = () => {
    const screens = useBreakpoint();
    const permissions = usePermissions();
    const { params, updateParams, resetPage } =
        usePaginationParams<raceFilterFormPaginated>({
            page: 1,
            size: 10,
            order_by: '-rank',
            ...initialFilterValues,
        });

    const { data, isFetching, refetch } = useGetRacekit(params, { retry: false });
    const [racekitEditData, setRacekitEditData] = useState<any>(undefined);

    const shouldHandleFieldCreation = permissions?.fields.add;

    const handleFiltersChange = (values: RaceFilterFormValues) => {
        updateParams(values);
        resetPage();
        refetch();
    };

    const handleMainFiltersChange = (mainParams: MainFiltersParams) => {
        updateParams(mainParams);
        resetPage();
    };
    const [showAddRacekitModal, setShowAddRacekitModal] = useState(false);
    const formId = 'events-filters-form';

    const handleCloseModal = () => {
        setShowAddRacekitModal(false);
        document.body.style.overflow = 'visible';
    }

    const handleOpenModal = () => {
        setShowAddRacekitModal(true);
        document.body.style.overflow = 'hidden';
    }

    return (
        <>
            <ContentTopBar
                title={"RaceKIT"}
                renderHeadingContent={
                    <MainFilters onChange={handleMainFiltersChange} />
                }
                renderButtons={
                    <>
                        {shouldHandleFieldCreation ? (
                            <>
                                <Button
                                    icon={!screens.xs ? <PlusOutlined /> : undefined}
                                    type='primary'
                                    onClick={handleOpenModal}
                                >
                                    {"Add RaceKIT"}
                                </Button>
                                <div className={`cstmrightmdl ${showAddRacekitModal && "show"}`}>
                                    <AddRacekitmodal showAddRacekitModal={showAddRacekitModal} refetch={refetch} onClose={handleCloseModal} racekitEditData={racekitEditData} />

                                </div>

                            </>
                        ) : null}
                    </>
                }
            />

            <ContentFilters formId={formId}>
                <RaceFilterForm
                    formId={formId}
                    handleFilter={handleFiltersChange}
                    initialValues={initialFilterValues}
                />
            </ContentFilters>

            <RacekitTable
                data={data}
                isLoading={isFetching}
                tableParams={params}
                updateParams={updateParams}
                refetch={refetch}
                racekitEditData={racekitEditData}
                setRacekitEditData={setRacekitEditData}
            />
            <Outlet />
        </>
    );
};

